import {
  Box,
  Chip,
  Grid,
  Button,
  TextField,
  Typography
} from "@mui/material";
import styled from "styled-components";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

export const PageCard = styled(Box)(({ theme }) => ({
  // padding: `${theme.spacing(3, 2)} ${theme.spacing(3, 2)}`,
  padding: theme.spacing(4, 2),
  backgroundColor: theme.palette.white.main,
  borderRadius: theme.palette.custom.borderRadius,
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(4),
}));

interface StatusTagProps {
  status: 'Active' | 'Pending' | 'Blocked' | string;
}

export const StatusChip = styled(Chip)<StatusTagProps>(({ theme, status }) => ({
  fontWeight: 'bold',
  color: "#fff !important",
  height: '28px',
  padding: `${theme.spacing(1, 5)} !important`,
  display: 'flex !important',
  alignItems: 'center',
  justifyContent: 'center',
  width: 'fit-content',
  borderRadius: `${theme.spacing(1, 3)} !important`,
  textTransform: 'capitalize',
}))

interface CustomAccordionProps {
  marginBottom: number;
}

export const CustomAccordion = styled(Box)<CustomAccordionProps>(({ theme, marginBottom }) => ({
  borderRadius: theme.palette.custom.borderRadius,
  padding: `${theme.spacing(3, 5)}`,
  border: `1px solid ${theme.palette.grey[200]}`,
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: theme.spacing(marginBottom),
}));

export const ExpandIcon = styled(ArrowForwardIosIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '1rem !important',
  marginLeft: theme.spacing(1),
}));

export const CustomLink = styled(Box)(({ theme }) => ({
  cursor: "pointer"
}))

export const VerificationContainer = styled(Grid)(({ theme }) => ({

}));

export const VerificationImageContainer = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  // marginLeft: theme.spacing(0.1),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '& img': {
    // You'll need to define a max size for the icon so it doesn't break the layout
    width: '40px',
    height: '40px',
  },
}))

export const ButtonGroupContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  justifyContent: 'flex-end',
  flexWrap: 'wrap',
}));

const ActionButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1, 3),
  borderRadius: `${theme.spacing(1)} !important`,
  textTransform: 'capitalize',
  minWidth: '200px !important',
}))

export const RejectButton = styled(ActionButton)(({ theme }) => ({
  borderColor: `${theme.palette.error.main} !important`,
  color: `${theme.palette.error.main} !important`,

  '&.Mui-disabled': {
    borderColor: `${theme.palette.grey[300]} !important`,
    color: `${theme.palette.grey[300]} !important`,
    opacity: 0.5
  }
}));

export const AcceptButton = styled(ActionButton)(({ theme }) => ({
  borderColor: theme.palette.success.main,
  color: theme.palette.white.main,

  '&.Mui-disabled': {
    borderColor: `${theme.palette.grey[300]} !important`,
    color: `${theme.palette.grey[300]} !important`,
    opacity: 0.5
  }

  // '&:hover': {
  //   backgroundColor: theme.palette.success.main,
  //   color: theme.palette.white.main,
  // }
}))


export const DateTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    borderRadius: 10,
    background: "#fff",
    height: 42,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#d2d6db",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.primary.main,
  },
}));

export const InterviewFormContainer = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: theme.spacing(3),
  width: "100%",
  paddingTop: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "1fr",
  },
}));

// Single full width field (Meeting Link)
export const FullWidthField = styled(Box)(({ theme }) => ({
  gridColumn: "1 / -1",
}));

// Label
export const FieldLabel = styled("div")(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 600,
  marginBottom: theme.spacing(1),
  color: theme.palette.text.primary,
}));

// Styled text input
export const StyledInput = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    borderRadius: 6,
    background: "#fff",
  },
}));


export const ScheduleInfoContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  padding: theme.spacing(2, 0),
  gap: theme.spacing(2),
  flexWrap: "wrap",
}));

export const ScheduleText = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  color: theme.palette.text.secondary,
  flexGrow: 1,
}));

export const ScheduleButtonGroup = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  flexShrink: 0,
}));

export const ClearScheduleButton = styled(Button)(({ theme }) => ({
  borderRadius: 12,
  border: `2px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.main,
  padding: "8px 24px",
  textTransform: "none",
  fontWeight: 600,
  background: "transparent",
  "&:hover": {
    background: theme.palette.primary.main + "10",
  },
}));

export const UpdateScheduleButton = styled(Button)(({ theme }) => ({
  borderRadius: 12,
  padding: "8px 24px",
  textTransform: "none",
  fontWeight: 600,
  background: theme.palette.primary.main,
  "&:hover": {
    background: theme.palette.primary.dark,
  },
}));
